import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31fa7440"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "r0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/mall/svgo-alert.png",
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" ご注意ください ")
], -1))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "r1" }, [
  /*#__PURE__*/_createTextVNode(" 現在、輸入代行サービスのページにいます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 以前はCKB Choiceをご利用いただいていました。CKB Choiceはアパレル専用で、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 円建てのオールイン価格で提供されています。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 引き続きCKB Choiceをご利用の場合は、"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/choice",
    style: {"color":"#0586FE"}
  }, "Choiceのトップページに戻って"),
  /*#__PURE__*/_createTextVNode("ご確認ください。 ")
], -1))
const _hoisted_4 = { class: "r2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "r2-1" }, [
  /*#__PURE__*/_createTextVNode(" ※輸入代行サービスとは？"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 輸入代行サービスでは、注文の進行に応じて料金が発生します（例：商品の費用、返品手数料、国際送料など）。また、オンラインECサイトやオフライン市場、ODM・OEMにも対応し、アパレル以外の生活雑貨や家電など、幅広い商品を取り扱っています。 ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "r2-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/mall/ecVSchoice.png",
    alt: ""
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "r2-3" }, " また、輸入代行サービスはD2CとB2Bの、二つのシステムに分かれています。 ", -1))
const _hoisted_8 = { class: "r2-4" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" D2CとB2Bの違い ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/mall/2c介绍.png",
  alt: ""
}, null, -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/mall/2b介绍.png",
  alt: ""
}, null, -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "r2-5" }, [
  /*#__PURE__*/_createTextVNode(" 【※ご注意】"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ·CKB ChoiceはデフォルトでD2Cシステムを使用し、B2Bシステムは輸入代行のみ対応します。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ·輸入代行商品をご購入の際は、まずD2CまたはB2Bシステムのいずれかをご選択ください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ·B2BとD2Cの手数料は異なる場合があります。詳細は"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.theckb.com/price/plan/",
    target: "_blank",
    style: {"color":"#0586FE"}
  }, "料金プラン"),
  /*#__PURE__*/_createTextVNode("をご参照ください。 ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "r3" }, " 上記の内容をよくお読みいただき、輸入代行ページに留まるか、CKB Choiceに戻るかをお選びください。 ", -1))
const _hoisted_16 = { class: "r4" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("CKB Choiceトップに戻る")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("このページに留まる")

import { useRoute } from 'vue-router'
import { ref, onMounted } from 'vue'
import { useUser } from '@/store'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import { t } from '@/plugins/i18n'

/** mall 和 client 都需要 */


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

const visible = ref(false)

const systemSource = ref(1)

const open = () => {
  location.replace('/choice')
}

onMounted(async () => {
  const user = useUser()
  if (user?.createTime) {
    const newUser = (new Date(user.createTime)).getTime() > (new Date('2025-02-01 00:00:00')).getTime()
    if (!newUser) return
  }
  const isChoiceUser = user?.ext?.includes('choice')
  if (!isChoiceUser) return
  const isGoods = /goods\/.+/.test(route.path)
  const isB2b = user.systemSource === 2
  systemSource.value = user.systemSource
  if (!(isGoods || isB2b)) return
  const [get, set] = useUserConfig(ENUM_CONFIG_CODE.NOT_FIRST_USE_B2B)
  const NOT_FIRST_USE_B2B = await get()
  if (NOT_FIRST_USE_B2B) return
  visible.value = true
  set(1)
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ElDialog = _resolveComponent("ElDialog")!

  return (_openBlock(), _createBlock(_component_ElDialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    width: 720,
    top: "5vh",
    "modal-class": " bc-intro"
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", null, [
              _hoisted_10,
              (systemSource.value === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(t)('ご利用中のシステム')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _hoisted_12,
              (systemSource.value === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(t)('ご利用中のシステム')), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_14
        ]),
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_el_button, { onClick: open }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})